import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useIntl } from "react-intl";

type UploadIconButtonProps = {
  label?: string;
} & IconButtonProps;

const UploadIconButton = (props: UploadIconButtonProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <Tooltip title={t({ id: props.label ?? "cloneLabel" })}>
      <div>
        <IconButton {...props}>
          <CloudUploadIcon />
        </IconButton>
      </div>
    </Tooltip>
  );
};

export default UploadIconButton;
